// extracted by mini-css-extract-plugin
export default {"btnAction":"WebhooksSection_btnAction__NXT5y","title":"WebhooksSection_title__O8X9n"};